import {connect} from "react-redux";
import DocumentSideBarButton from "../../../../components/Chat/shared/ChatTitle/DocumentSideBarButton";
import {toggleSideBar} from "../../../../actions/chatCase/document";

const MapStateToProps = (state) => ({
showSideBar: state.chatCase.showSideBar
});

const MapDispatchToProps = (dispatch) => ({
toggleSideBar: (bool) => {
dispatch(toggleSideBar(bool));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(DocumentSideBarButton);
